import { ActionType } from '@core/models/banners/enums';

export default {
    methods: {
        onClick({ link, actionType }: { link: string , actionType: ActionType }) {
            switch (actionType) {
                case ActionType.openNewTab:
                    this.openNewTab(link);
                    break;
                case ActionType.openInAppLink:
                    this.goToPage(link);
                    break;
                case ActionType.openPopup:
                    this.openPopup();
                    break;
                default:
                    break;
            }
        },
        openNewTab(link: string) {
            window.open(link, '_blank');
        },
        goToPage(link: string) {
            (this as any).$router.push(link);
        },
        openPopup() {
            // TODO: next PR
        }
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/shared/banners/BannerContainerMixin.ts